import React from 'react';
import S from 'StyledResetPasswordForm.js';
import {Field, reduxForm, SubmissionError} from 'redux-form';
import {translation} from 'utilsHelper.js';
import _get from 'lodash/get';

// Validation
import validation from 'sb-validate-js/validate.js';
import validators from 'validators.enum.js';

const validate = values => {
    const errors = validation(values, validators.RESET_PASSWORD);
    return errors;
};

const renderField = ({
    input,
    label,
    type,
                         disabled,
    meta: {touched, error, warning, submitFailed}
}) => {
    return (
        <S.Row>
            <S.InputWrapper>
                <S.Input {...input} type={type} required="required" disabled={disabled}/>
                <S.Label>{label}</S.Label>
                {(touched || submitFailed) && ((error && <S.Error>{error[0]}</S.Error>) || (warning &&
                <S.Error>{warning}</S.Error>))}
            </S.InputWrapper>
        </S.Row>
    )
};

const ResetPasswordForm = ({resetPasswordOnSubmit, handleSubmit, submitting, error, submitSucceeded}) => {

    const onFormSubmit = async(values) => {

        try {
            const verificationCode = location.pathname && location.pathname.replace(/\/set\-new\-password\/\d+\/(.+)\/.+/, '$1');
            const customerId = location.pathname && location.pathname.replace(/\/set\-new\-password\/(\d+)\/.+\/.+/, '$1');
            const params = {
                password: _get(values, 'newPassword'),
                verificationCode,
                customerId
            };

            await resetPasswordOnSubmit(params);
        } catch (err) {
            throw new SubmissionError({_error: err});
        }
    };

    return (
        <S.ResetPasswordForm method="post" onSubmit={handleSubmit(onFormSubmit)} autocomplete="off" noValidate>

                {submitSucceeded && (
                    <S.SubmissionSuccess className="submission-success">
                        {translation('setNewPassword_success')}
                    </S.SubmissionSuccess>
                )}

                {error && <S.SubmissionError className="submission-error">{error}</S.SubmissionError>}

                <Field
                    name="newPassword"
                    type="password"
                    component={renderField}
                    label={translation('newPassword')}
                    disabled={submitSucceeded}
                />
                <Field
                    name="confirmPassword"
                    type="password"
                    component={renderField}
                    label={translation('confirmNewPassword')}
                    disabled={submitSucceeded}
                />

                <S.SubmitBtn type="submit" disabled={submitting||submitSucceeded}>{translation('setNewPassword')}</S.SubmitBtn>

        </S.ResetPasswordForm>
    );
};

export default reduxForm({
    form: 'resetPasswordForm',
    validate
})(ResetPasswordForm);
